import Button from "components/Button";
import useLabs from "store/labs/service-hook";
import { useState } from "react";

const LiveEventButton = ({ lab, t = (d) => d }) => {
  const { fetchEventUrl } = useLabs();
  const [loadingEventUrl, setLoadingEventUrl] = useState(false);

  // FUNCTION TO FETCH AND OPEN LIVE EVENT URL
  const fetchMeetingUrl = async () => {
    if (!lab) return; // RETURN IF NO LAB PROVIDED
    setLoadingEventUrl(true); 
    try {
      const response = await fetchEventUrl(lab?.slug);
      if (!response || !response?.event_url) return; // RETURN IF NO URL
      window.open(response?.event_url, "_blank", "noreferrer"); // OPEN EVENT URL IN NEW TAB
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingEventUrl(false); 
    }
  };

  return (
    <Button
      classes="w-full mt-2"
      height="40px"
      color="yellow"
      onClick={fetchMeetingUrl}
      loading={loadingEventUrl}
    >
      {t("Live Event")}
    </Button>
  );
};

export default LiveEventButton;
